import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow, ExpandableCheckboxGrid } from 'shared/components/AdvancedFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectInfrastructureFilter } from 'shared/selectors/advancedFilters';
import { EInfrastructureItem } from '../../../../../../../packages/api-models/common/json_query';
import { NonEmptyArray } from '../../../../../../../packages/JsonQuery';

export const InfrastructureContainer: FC = () => {
  const { label, value, options } = useSelector(selectInfrastructureFilter);

  const onChange = useFilterChangeCallback();

  const handleChange = useCallback(
    (next: EInfrastructureItem[]) => {
      onChange({
        action: 'setInfrastructure',
        arguments: [next.length > 0 ? (next as NonEmptyArray<EInfrastructureItem>) : null],
      });
    },
    [onChange],
  );

  const cleanValue = value.filter((v): v is EInfrastructureItem => v !== null);

  return (
    <AdvancedFilterRow label={label}>
      <ExpandableCheckboxGrid options={options} value={cleanValue} onChange={handleChange} />
    </AdvancedFilterRow>
  );
};
